
import { convRate, latestPriceEth, latestPriceBtc, } from "@cachables";
import { getTokenDefinition, } from "@bracket/chainography";
import type { AmountString, TokenIdentifier } from "@bracket/types";

export const toUSD = async ( amount: AmountString, token: TokenIdentifier ) => {

  const tok = getTokenDefinition(token);

  if(tok.symbol === "USDC") {
    return Number(amount);
  }

  if(tok.symbol === "WBTC") {
    const [
      price,
      rate,
    ] = await Promise.all([
      latestPriceBtc(),
      1,
    ]);
    return Number(amount) * price * rate;
  }

  const [
    ethprice,
    rate,
  ] = await Promise.all([
    latestPriceEth(),
    convRate({ token, }),
  ]);

  const amountUSD = Number(amount) * rate * ethprice;

  return amountUSD;



}